"use client";

import { useParams } from "next/navigation";
import { motion as _motion } from "framer-motion";
const motion: any = _motion;
import { messages } from "@/lib/i18n";
import Sparkles from "./Sparkle";

export default function HowWeWorkCreative() {
  const params = useParams();
  const locale = (params?.locale ?? "en") as "en" | "ar" | "fr";
  const t = messages[locale] ?? messages.en;
  const isRTL = locale === "ar";

  return (
    <section
      className={`relative w-full bg-black px-4 py-28 ${isRTL ? "rtl" : ""}`}
    >
      <div className="mx-auto max-w-6xl">
        <div className="mb-20 text-center">
          <h2 className="text-3xl md:text-4xl font-serif font-semibold text-gray-100">
            {t.howWeWork.title}
          </h2>
          <p className="mt-3 text-gray-400">{t.howWeWork.subtitle}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-20 items-stretch">
          {t.howWeWork.steps.map((step, index) => {
            const isLastOdd =
              t.howWeWork.steps.length % 2 === 1 &&
              index === t.howWeWork.steps.length - 1;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className={`relative z-10
                  w-full h-full
                  rounded-[2.5rem]
                  glass-panel-gold neon-card
                  px-10 py-10 md:px-12
                  shadow-[0_0_80px_rgba(212,175,55,0.15)]
                  ${isLastOdd ? "md:col-span-2 md:w-[calc(50%-2rem)] md:justify-self-center" : ""}
                  ${isRTL ? "text-right" : "text-left"}`}
              >
                <div
                  className={`absolute -top-6 ${isRTL ? "right-8" : "left-8"}
                  w-12 h-12 rounded-full bg-yellow-500 text-black font-bold flex items-center justify-center
                  text-lg shadow-lg
                `}
                >
                  {index + 1}
                </div>

                <h3 className="mt-6 text-xl font-semibold text-gray-100">
                  {step.title}
                </h3>
                <p className="mt-2 text-gray-400 leading-relaxed">
                  {step.description}
                </p>
                <Sparkles />
              </motion.div>
            );
          })}
        </div>
        <p className="mt-20 text-center text-sm text-gray-500">
          {t.howWeWork.footer}
        </p>
      </div>
    </section>
  );
}
